export const permissionCodeConstant = {
  material_request_create: "material_request.create",
  material_request_edit: "material_request.edit",
  material_request_delete: "material_request.delete",
  material_request_approve: "material_request.approve",
  material_request_reject: "material_request.reject",
  material_request_view: "material_request.view",
  purchase_request_create: "purchase_request.create",
  purchase_request_edit: "purchase_request.edit",
  purchase_request_delete: "purchase_request.delete",
  purchase_request_approve: "purchase_request.approve",
  purchase_request_reject: "purchase_request.reject",
  purchase_request_view: "purchase_request.view",
  service_contractor_create: "service_contractor.create",
  service_contractor_update: "service_contractor.update",
  service_contractor_delete: "service_contractor.delete",
  service_contractor_list: "service_contractor.list",
  service_contractor_search: "service_contractor.search",
  service_contractor_map_user: "service_contractor.map_user",
  tax_group_create: "tax_group.create",
  tax_group_update: "tax_group.update",
  tax_group_delete: "tax_group.delete",
  tax_group_view_list: "tax_group.view_list",
  create_role: "create_role",
  update_role: "update_role",
  view_update_role: "view_update_role",
  delete_role: "delete_role",
  view_list_role: "view_list_role",
  create_user: "create_user",
  update_user: "update_user",
  view_list_user: "view_list_user",
  mapping_user_asset: "mapping_user_asset",
  mapping_user_branch: "mapping_user_branch",
  delete_user: "delete_user",
  reset_password: "reset_password",
  quotation_view_list: "quotation.view_list",
  quotation_create: "quotation.create",
  quotation_edit: "quotation.edit",
  quotation_delete: "quotation.delete",
  quotation_approve: "quotation.approve",
  quotation_reject: "quotation.reject",
  purchase_order_create: "purchase_order.create",
  purchase_order_edit: "purchase_order.edit",
  purchase_order_delete: "purchase_order.delete",
  purchase_receipt_create: "purchase_receipt.create",
  purchase_receipt_edit: "purchase_receipt.edit",
  purchase_receipt_view: "purchase_receipt.view",
  purchase_receipt_delete: "purchase_receipt.delete",
  purchase_receipt_approve: "purchase_receipt.approve",
  purchase_receipt_reject: "purchase_receipt.reject",
  warehouse_request_create: "warehouse_request.create",
  warehouse_request_edit: "warehouse_request.edit",
  warehouse_request_view: "warehouse_request.view",
  warehouse_request_delete: "warehouse_request.delete",
  warehouse_request_approve: "warehouse_request.approve",
  warehouse_request_reject: "warehouse_request.reject",
  warehouse_export_create: "warehouse_export.create",
  warehouse_export_edit: "warehouse_export.edit",
  warehouse_export_view: "warehouse_export.view",
  warehouse_export_delete: "warehouse_export.delete",
  warehouse_export_approve: "warehouse_export.approve",
  warehouse_export_reject: "warehouse_export.reject",
  return_to_supplier_create: "return_to_supplier.create",
  return_to_supplier_edit: "return_to_supplier.edit",
  return_to_supplier_view: "return_to_supplier.view",
  return_to_supplier_delete: "return_to_supplier.delete",
  return_to_supplier_approve: "return_to_supplier.approve",
  return_to_supplier_reject: "return_to_supplier.reject",
  inventory_view: "inventory.view",
  quotation_compare_view: "quotation_compare.view",
  quotation_compare_select_quotation: "quotation_compare.select_quotation",
  asset_view_list: "asset.view_list",
  asset_view_detail: "asset.view_detail",
  asset_create: "asset.create",
  asset_update: "asset.update",
  asset_delete: "asset.delete",
  asset_move: "asset.move",
  asset_search_Qr_code: "asset.search_Qr_code",
  asset_view_move_history: "asset.view_move_history",
  asset_search: "asset.search",
  preventive_view_list: "preventive.view_list",
  preventive_view_detail: "preventive.view_detail",
  preventive_create: "preventive.create",
  preventive_update: "preventive.update",
  preventive_delete: "preventive.delete",
  preventive_start_stop: "preventive.start_stop",
  preventive_search: "preventive.search",
  schedule_preventive_view_list: "schedule_preventive.view_list",
  schedule_preventive_view_detail: "schedule_preventive.view_detail",
  schedule_preventive_update: "schedule_preventive.update",
  schedule_preventive_delete: "schedule_preventive.delete",
  schedule_preventive_comment: "schedule_preventive.comment",
  schedule_preventive_export_pdf: "schedule_preventive.export_pdf",
  schedule_preventive_cancel: "schedule_preventive.cancel",
  schedule_preventive_assign_engineer: "schedule_preventive.assign_engineer",
  schedule_preventive_view_items: "schedule_preventive.view_items",
  schedule_preventive_view_downtime: "schedule_preventive.view_downtime",
  schedule_preventive_close_or_reopen: "schedule_preventive.close_or_reopen",
  breakdown_view_list: "breakdown.view_list",
  breakdown_view_detail: "breakdown.view_detail",
  breakdown_create: "breakdown.create",
  breakdown_update: "breakdown.update",
  breakdown_delete: "breakdown.delete",
  breakdown_comment: "breakdown.comment",
  breakdown_close_and_reopen: "breakdown.close_and_reopen",
  breakdown_comfirm_experimental_fix: "breakdown.comfirm_experimental_fix",
  breakdown_assign_engineer: "breakdown.assign_engineer",
  breakdown_cancel_ticket: "breakdown.cancel_ticket",
  breakdown_view_downtime: "breakdown.view_downtime",
  breakdown_experimental_fix: "breakdown.experimental_fix",
  ticket_view_list: "ticket.view_list",
  ticket_view_detail: "ticket.view_detail",
  spare_view_list: "spare.view_list",
  spare_view_detail: "spare.view_detail",
  spare_approve: "spare.approve",
  maintenance_contract_view_list: "maintenance_contract.view_list",
  maintenance_contract_view_detail: "maintenance_contract.view_detail",
  maintenance_contract_create: "maintenance_contract.create",
  maintenance_contract_update: "maintenance_contract.update",
  maintenance_contract_delete: "maintenance_contract.delete",
  maintenance_contract_assign_executor: "maintenance_contract.assign_executor",
  customer_view_list: "customer.view_list",
  customer_create: "customer.create",
  customer_update: "customer.update",
  customer_delete: "customer.delete",
  customer_search: "customer.search",
  customer_assetmaintenance_list: "customer.assetmaintenance_list",
  main_equipment_view_list: "main_equipment.view_list",
  main_equipment_create: "main_equipment.create",
  main_equipment_update: "main_equipment.update",
  main_equipment_delete: "main_equipment.delete",
  main_equipment_search: "main_equipment.search",
  sub_equipment_view_list: "sub_equipment.view_list",
  sub_equipment_create: "sub_equipment.create",
  sub_equipment_update: "sub_equipment.update",
  sub_equipment_delete: "sub_equipment.delete",
  sub_equipment_search: "sub_equipment.search",
  manufacturer_view_list: "manufacturer.view_list",
  manufacturer_create: "manufacturer.create",
  manufacturer_update: "manufacturer.update",
  manufacturer_delete: "manufacturer.delete",
  manufacturer_search: "manufacturer.search",
  supplier_view_list: "supplier.view_list",
  supplier_create: "supplier.create",
  supplier_update: "supplier.update",
  supplier_delete: "supplier.delete",
  supplier_search: "supplier.search",
  equipment_category_view_list: "equipment_category.view_list",
  equipment_category_create: "equipment_category.create",
  equipment_category_update: "equipment_category.update",
  equipment_category_delete: "equipment_category.delete",
  equipment_category_search: "equipment_category.search",
  equipment_hierarchy_view_list: "equipment_hierarchy.view_list",
  equipment_hierarchy_create: "equipment_hierarchy.create",
  equipment_hierarchy_update: "equipment_hierarchy.update",
  equipment_hierarchy_details: "equipment_hierarchy.details",
  equipment_hierarchy_delete: "equipment_hierarchy.delete",
  equipment_hierarchy_search: "equipment_hierarchy.search",
  equipment_model_view_list: "equipment_model.view_list",
  equipment_model_create: "equipment_model.create",
  equipment_model_update: "equipment_model.update",
  equipment_model_delete: "equipment_model.delete",
  equipment_model_search: "equipment_model.search",
  equipment_model_view_detail: "equipment_model.view_detail",
  spare_part_category_view_list: "spare_part_category.view_list",
  spare_part_category_create: "spare_part_category.create",
  spare_part_category_update: "spare_part_category.update",
  spare_part_category_delete: "spare_part_category.delete",
  spare_part_categoryt_search: "spare_part_category.search",
  sub_spare_part_category_view_list: "sub_spare_part_category.view_list",
  sub_spare_part_category_create: "sub_spare_part_category.create",
  sub_spare_part_category_update: "sub_spare_part_category.update",
  sub_spare_part_category_delete: "sub_spare_part_category.delete",
  sub_spare_part_category_search: "sub_spare_part_category.search",
  spare_part_replacement_view_list: "spare_part_replacement.view_list",
  spare_part_replacement_create: "spare_part_replacement.create",
  spare_part_replacement_update: "spare_part_replacement.update",
  spare_part_replacement_delete: "spare_part_replacement.delete",
  spare_part_replacement_search: "spare_part_replacement.search",
  building_view_list: "building.view_list",
  building_create: "building.create",
  building_update: "building.update",
  building_delete: "building.delete",
  building_bulk_upload: "building.bulk_upload",
  floor_view_list: "floor.view_list",
  floor_create: "floor.create",
  floor_update: "floor.update",
  floor_delete: "floor.delete",
  floor_bulk_upload: "floor.bulk_upload",
  department_view_list: "department.view_list",
  department_create: "department.create",
  department_update: "department.update",
  department_delete: "department.delete",
  department_bulk_upload: "department.bulk_upload",
  branch_view_list: "branch.view_list",
  branch_create: "branch.create",
  branch_update: "branch.update",
  branch_delete: "branch.delete",
  branch_search: "branch.search",
  service_view_list: "service.view_list",
  service_create: "service.create",
  service_update: "service.update",
  service_delete: "service.delete",
  service_search: "service.search",
  service_package_create: "service_package.create",
  service_package_update: "service_package.update",
  service_package_delete: "service_package.delete",
  service_package_view_list: "service_package.view_list",
  service_package_search: "service_package.search",
  service_package_view_detail: "service_package.view_detail",
  purchase_order_view: "purchase_order.view",
  schedule_preventive_my_task_view_list:
    "schedule_preventive_my_task.view_list",
  schedule_preventive_my_task_accept: "schedule_preventive_my_task.accept",
  schedule_preventive_my_task_rejected: "schedule_preventive_my_task.rejected",
  schedule_preventive_my_task_checkin_checkout:
    "schedule_preventive_my_task.checkin_checkout",
  uom_view_list: "uom.view_list",
  uom_update: "uom.update",
  uom_create: "uom.create",
  uom_delete: "uom.delete",
  reminder_view: "reminder.view",
  configuration_workflow_view_list: "configuration_workflow.view_list",
  configuration_workflow_update: "configuration_workflow.update",
  company_setting_view_list: "company_setting.view_list",
  company_setting_update: "company_setting.update",
  contractand_view_list: "contractand.view_list",
  contractand_create: "contractand.create",
  contractand_update: "contractand.update",
  contractand_delete: "contractand.delete",
  compliance_view_list: "compliance.view_list",
  compliance_create: "compliance.create",
  compliance_update: "compliance.update",
  compliance_delete: "compliance.delete",
  report_asset_performance: "report.asset_performance",
  report_asset_depreciation: "report.asset_depreciation",
  report_processing_status_report_breakdown:
    "report.processing_status_report_breakdown",
  report_spare_movement_report: "report.spare_movement_report",
  report_spare_parts_usage_summary_report:
    "report.spare_parts_usage_summary_report",
  report_asset_maintenance: "report.asset_maintenance",
  report_processing_status_report_schedule_preventive:
    "report.processing_status_report_schedule_preventive",
  report_report_asset_maintenance: "report.report_asset_maintenance",
  report_report_engineer_performance_in_breakdown:
    "report.report_engineer_performance_in_breakdown",
  report_report_engineer_performance_in_schedule_preventive:
    "report.report_engineer_performance_in_schedule_preventive",
  report_work_report_by_person: "report.work_report_by_person",
  preventive_monitoring_view_history: "preventive_monitoring.view_history",
  preventive_monitoring_view_list: "preventive_monitoring.view_list",
  preventive_monitoring_update: "preventive_monitoring.update",
  breakdown_contract_view_list: "breakdown_contract.view_list",
  breakdown_group_view_list: "breakdown_group.view_list",
  schedule_preventive_group_view_list: "schedule_preventive_group.view_list",
  required_spare_part_schedule_preventive_view_list:
    "required_spare_part_schedule_preventive.view_list",
  required_spare_part_schedule_preventive_approve:
    "required_spare_part_schedule_preventive.approve",
  required_spare_part_schedule_preventive_view:
    "required_spare_part_schedule_preventive.view",
  calibration_work_contract_view_list: "calibration_work_contract.view_list",
  calibration_view_list: "calibration.view_list",
  calibration_create: "calibration.create",
  calibration_update: "calibration.update",
  calibration_start: "calibration.start",
  calibration_stop: "calibration.stop",
  calibration_delete: "calibration.delete",
  calibration_assign: "calibration.assign",
  calibration_change_of_calibration_contract:
    "calibration.change_of_calibration_contract",
  calibration_work_view_list: "calibration_work.view_list",
  calibration_work_cancel: "calibration_work.cancel",
  calibration_work_delete: "calibration_work.delete",
  calibration_work_commet: "calibration_work.commet",
  calibration_work_view_detail: "calibration_work.view_detail",
  calibration_work_assign: "calibration_work.assign",
  calibration_work_close: "calibration_work.close",
  calibration_work_reopen: "calibration_work.reopen",
  calibration_work_my_view_list: "calibration_work_my.view_list",
  calibration_work_my_accept: "calibration_work_my.accept",
  calibration_work_my_reject: "calibration_work_my.reject",
  calibration_work_my_calbrated_comfirm:
    "calibration_work_my.calbrated_comfirm",
  calibration_work_group_view_list: "calibration_work_group.view_list",
  preventive_conditioon_based_schedule_view_list:
    "preventive_conditioon_based_schedule.view_list",
  preventive_conditioon_based_schedule_view_history:
    "preventive_conditioon_based_schedule.view_history",
  preventive_conditioon_based_schedule_enter_measured_value:
    "preventive_conditioon_based_schedule.enter_measured_value",
  stock_receipt_create: "stock_receipt_create",
  stock_receipt_edit: "stock_receipt_edit",
  stock_receipt_delete: "stock_receipt_delete",
  stock_receipt_approve: "stock_receipt_approve",
  stock_receipt_reject_reason: "stock_receipt_reject_reason",
  stock_receipt_view_request: "stock_receipt_view_request",

  stock_issue_use_create: "stock_issue_use_create",
  stock_issue_use_edit: "stock_issue_use_edit",
  stock_issue_use_delete: "stock_issue_use_delete",
  stock_issue_use_approve: "stock_issue_use_approve",
  stock_issue_use_reject_reason: "stock_issue_use_reject_reason",
  stock_issue_use_view_request: "stock_issue_use_view_request",

  stock_issue_liquidation_create: "stock_issue_liquidation_create",
  stock_issue_liquidation_edit: "stock_issue_liquidation_edit",
  stock_issue_liquidation_delete: "stock_issue_liquidation_delete",
  stock_issue_liquidation_approve: "stock_issue_liquidation_approve",
  stock_issue_liquidation_reject_reason:
    "stock_issue_liquidation_reject_reason",
  stock_issue_liquidation_view_request: "stock_issue_liquidation_view_request",
  inventory_spareparts: "inventory_spareparts",
  inventory_assets: "inventory_assets",
  calibration_work_view_list: "calibration_work.view_list",
  calibration_work_cancel: "calibration_work.cancel",
  calibration_work_delete: "calibration_work.delete",
  calibration_work_commet: "calibration_work.commet",
  calibration_work_view_detail: "calibration_work.view_detail",
  calibration_work_assign: "calibration_work.assign",
  calibration_work_close: "calibration_work.close",
  calibration_work_reopen: "calibration_work.reopen",
  calibration_work_my_view_list: "calibration_work_my.view_list",
  calibration_work_my_accept: "calibration_work_my.accept",
  calibration_work_my_reject: "calibration_work_my.reject",
  calibration_work_my_calbrated_comfirm:
    "calibration_work_my.calbrated_comfirm",
  calibration_work_group_view_list: "calibration_work_group.view_list",
  preventive_conditioon_based_schedule_view_list:
    "preventive_conditioon_based_schedule.view_list",
  preventive_conditioon_based_schedule_view_history:
    "preventive_conditioon_based_schedule.view_history",
  preventive_conditioon_based_schedule_enter_measured_value:
    "preventive_conditioon_based_schedule.enter_measured_value",
  inventory_assets: "inventory_assets",
  property_inspection_close: "property_inspection.close",
  property_inspection_cancal: "property_inspection.cancel",
  property_inspection_view: "property_inspection.view",
  property_inspection_create: "property_inspection.create",
  property_inspection_update: "property_inspection.update",
  asset_approve_cancel: "asset.approve_cancel",
  asset_cancel: "asset.cancel"
};
